<template>
    <div>
      <purpose-of-meet-list></purpose-of-meet-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  